<template>
  <div
    class="flex-1 px-5 py-5 m-2 mb-10 text-center text-gray-700 border-solid rounded border-primary-light"
  >
    <div class="flex-wrap justify-center lg:flex lg:items-center h-96 w-96">
      <div class="m-5 lg:flex-shrink-0 ">
        <img
          class="object-scale-down h-48 rounded-lg w-84"
          v-bind:src="value.previewImg"
          alt=""
        />
      </div>
      <div class="mt-4 lg:mt-0">
        <div class="text-2xl">{{ value.name }}</div>
        <p>{{ value.description }}</p>
        <Button @click="updateValue" class="border-solid bg-primary-dark">
          Select this template
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../components/forms/Button.vue";

export default {
  name: "register-select-box",
  components: {
    Button,
  },
  props: {
    value: {
      type: Object,
    },
  },
  methods: {
    updateValue: function() {
      this.$gtm.trackEvent({
        event: "click-label-select",
        category: "Register",
        action: "click",
        label: `Clicked template ${this.value.name}`,
        value: this.value.name,
      });
      this.$emit("input", this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  max-width: 75%;
}
.container {
  margin-top: 10px;
  padding: 10px;
  border: solid 1px theme("colors.secondary");
  border-radius: 5px;
  box-shadow: 0px 0px 10px theme("colors.primary-dark");
}
.image {
  border: solid 1px white;
  border-radius: 5px;
  padding: 10px;
  width: 100px;
  height: 100px;
  margin-right: 20px;
}

.button {
  background-color: theme("colors.primary-light");
  height: 60px;
  color: white;
  border: solid 1px theme("colors.secondary");
}
</style>
